/**
 * When you create an instance of the AcceptedError, you can change the retry if you like. So not all
 * API calls have to be retried at the same frequency.
 */
export class AcceptedError extends Error {
  constructor(public retryDelay: number, ...params: Array<string | undefined>) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if ((Error as any).captureStackTrace) {
      (Error as any).captureStackTrace(this, AcceptedError);
    }

    this.name = 'AcceptedError';
  }
}
